import { money, tag } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const FetchPayOverTimeDetails = gql`
  fragment TransactionRowComponentFragment on TransactionRowComponent {
    id
    primaryDetail {
      copy
    }
    primaryText {
      copy
    }
    secondaryDetail {
      copy
    }
    secondaryText {
      copy
    }
    tags {
      ...tag
    }
  }

  query PayOverTimeDetails {
    __typename
    payOverTimeDetails {
      __typename
      ... on PayOverTimeDetailsSuccess {
        closedLoans {
          children {
            ...TransactionRowComponentFragment
          }
          icon {
            id
            fallbackURL
            iconKey
            tint
            size
          }
          id
          title {
            copy
          }
        }
        id
        outstandingBalance {
          ...money
        }
        openLoans {
          children {
            ...TransactionRowComponentFragment
          }
          icon {
            id
            fallbackURL
            iconKey
            tint
            size
          }
          id
          title {
            copy
          }
        }
      }
      ... on PayOverTimeDetailsError {
        code
        message
        title
      }
    }
  }

  ${money}
  ${tag}
`;

export default FetchPayOverTimeDetails;
